import * as v from 'valibot';
import { t } from 'i18next';
import { type SettingPrinterRequest } from '~/api';

export const SettingPrinterRequestSchema = v.object({
	name: v.pipe(
		v.string(t('Prosím nenechávejte toto pole prázdné.')),
		v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.')),
	),
	street: v.pipe(
		v.string(t('Prosím nenechávejte toto pole prázdné.')),
		v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.')),
	),
	streetNumber: v.nullable(v.string()),
	city: v.pipe(
		v.string(t('Prosím nenechávejte toto pole prázdné.')),
		v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.')),
	),
	zip: v.pipe(
		v.string(t('Prosím nenechávejte toto pole prázdné.')),
		v.nonEmpty(t('Prosím nenechávejte toto pole prázdné.')),
	),
	type: v.picklist<SettingPrinterRequest['type'][], string>(
		[ 'formatting', 'printing' ],
		t('Vyberte možnost.'),
	),
	adminIds: v.array(v.number()),
});
